module.exports = __webpack_public_path__ + "img/mollusc.62031a58.svg";